"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTokenFromSessionStorage = exports.useRefreshTokenStorage = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const use_persisted_state_1 = __importDefault(require("use-persisted-state"));
exports.useRefreshTokenStorage = use_persisted_state_1.default('oauth-refresh-token');
function useTokenFromSessionStorage(accessTokenUri, clientId, client) {
    const [refreshToken] = exports.useRefreshTokenStorage();
    const res = react_query_1.useQuery(['refresh-token-getter', accessTokenUri, clientId], () => __awaiter(this, void 0, void 0, function* () {
        const res = yield fetch(accessTokenUri, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                grant_type: 'refresh_token',
                client_id: clientId,
                refresh_token: refreshToken,
            }).toString(),
        });
        if (!res.ok) {
            throw new Error('Invalid response from SSO provider.');
        }
        const data = (yield res.json());
        const token = client === null || client === void 0 ? void 0 : client.createToken(data.access_token, data.refresh_token, data.token_type, data);
        return token;
    }), {
        enabled: !!client && !!refreshToken && !!accessTokenUri && !!clientId,
        cacheTime: 5 * 60 * 1000,
        staleTime: 5 * 60 * 1000,
        retry: false,
    });
    return react_1.useMemo(() => (Object.assign(Object.assign({}, res), { token: res.data })), [res]);
}
exports.useTokenFromSessionStorage = useTokenFromSessionStorage;
//# sourceMappingURL=useTokenFromSessionStorage.js.map